import { Center, Image, Overlay, Stack } from "@mantine/core";
import { IconPlayerPlay } from "@tabler/icons-react";
import React, { useState } from "react";
import { PlayIcon } from "../Icons/SvgIcons";

const IframeWithPlaceholder = ({ videoId, thumbnail }) => {
  const [play, setPlay] = useState(false);

  return (
    <Stack ml="auto" flex={1} style={{ position: "relative" }} align="end">
      {play ? (
        <iframe
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
          title="YouTube video player"
          allowFullScreen
          width="100%"
          height={400}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          style={{
            borderRadius: 12,
            overflow: "hidden",
            border: "1px solid #00000033",
          }}
        />
      ) : (
        <div
          style={{
            position: "relative",
            width: "100%",
            height: 400,
            cursor: "pointer",
            borderRadius: 12,
            overflow: "hidden",
            border: "1px solid #00000033",
            background: `url(${thumbnail})`,
            backgroundSize: "cover",
            backgroundPosition: "left top",
          }}
          onClick={() => setPlay(true)}
        >
          <PlayIcon
            variant="light"
            color="#fcfbff"
            size={128}
            iconSize={64}
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 10,
            }}
            radius={64}
            className="play-button"
          />
        </div>
      )}
    </Stack>
  );
};

export default IframeWithPlaceholder;
